module.exports = __webpack_public_path__ + "b32529671a0c83c64c8224982690d81d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2020-07-18/whats-new.html
// module id = 2249
// module chunks = 0